import constants from 'common/constants'

import {ONBOARDING_TIMETABLE_COUNTRIES} from './ActionTypes/ApiActionTypes'

/**
 * GET timetable/countries — the signup form's country list plus the country the
 * tenant is already on (`currentSelected: {code, name, raw}`, all-null when the
 * application row has none stored). Used by the wizard's Setup Basics screen to
 * build the country dropdown and preselect the school's country.
 */
export const getTimetableCountries = (onSuccess, onFailure) => {
  return {
    type: ONBOARDING_TIMETABLE_COUNTRIES,
    payload: {
      apiUrl: constants.api_timetable_countries,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
